import Section from '../base/Section';

export default function ServiceAreasSection() {
  const areas = [
    'Granollers Centro',
    'Sant Miquel',
    'Sant Nicolau',
    'Can Bassa',
    'Can Gili',
    'Lledoner',
    'Canovelles',
    'Les Franqueses del Vallès',
    'La Roca del Vallès',
    'Montmeló',
    'Parets del Vallès',
    'Cardedeu',
    'Mollet del Vallès',
    'La Garriga',
    'Lliçà d\'Amunt',
    'Lliçà de Vall',
  ];

  return (
    <Section background="dark" padding="lg">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
        {/* Left Column - Text */}
        <div className="lg:col-span-2">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Servicio en todo el Vallès Oriental
          </h2>
          <p className="text-white/90 text-lg mb-8 leading-relaxed">
            Ofrecemos nuestros servicios de vaciado de pisos, limpieza por síndrome de Diógenes y retirada de muebles en{' '}
            <a 
              href="https://es.wikipedia.org/wiki/Granollers" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="text-primary hover:underline font-semibold cursor-pointer"
            >
              Granollers y todas las localidades del Vallès Oriental
            </a>
            . Cobertura completa en la comarca con desplazamiento incluido.
          </p>
          <div className="grid grid-cols-2 gap-3">
            {areas.map((area, index) => (
              <div key={index} className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-primary text-xl w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span className="text-white/90">{area}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column - Map Illustration */}
        <div className="lg:col-span-3">
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/817a946f578920f0d7e7355d5ea442dc.jpg"
              alt="Mapa de servicio Vallès Oriental"
              className="w-full h-auto rounded-2xl shadow-2xl"
              loading="lazy"
              decoding="async"
              width="800"
              height="600"
            />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div className="relative">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center shadow-2xl animate-pulse">
                  <i className="ri-map-pin-fill text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
                </div>
                <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap bg-white text-secondary px-4 py-2 rounded-full font-bold shadow-lg">
                  Granollers
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
